<template>
  <vue-scroll class="view box grow flex grid-2">
    <div class="box grow login-container">
      <div class="grid-logo">
        <div class="logo-box align-vertical">
          <div class="logo-container align-vertical-middle">
            <div>
              <img class="logo-letter" src="/static/images/horizontal_logo_white.svg" alt="logo" />
              <div class="logo-desc">Autonomous Detection and Response</div>
            </div>
          </div>
        </div>
      </div>
      <el-form
        class="flex align-center grid-content login-page align-vertical"
        :model="userForm"
        :rules="userRules"
        ref="resetRef"
      >
        <div class="box form-wrapper align-vertical-middle">
          <div class="form-box">
            <div class="small-font h3">
              <h3>Reset Password</h3>
            </div>
            <div v-if="!isPasswordEmailSent">
              <float-label class="styled">
                <el-form-item prop="email">
                  <el-input type="email" placeholder="Email Address" v-model.trim="userForm.email" />
                </el-form-item>
              </float-label>

              <div v-if="passwordEmailSentMessage" class="styled message">
                <label>{{passwordEmailSentMessage}}</label>
              </div>

              <div class="flex text-center center mt-8 mb-8">
                <el-button
                  plain
                  size="small"
                  @click="login"
                  class="box grow login-btn"
                >Back to Login</el-button>

                <el-button
                  plain
                  size="small"
                  @click="emailPasswordReset"
                  class="box grow login-btn"
                >Send Reset Link</el-button>
              </div>
            </div>
            <div v-else>
              <div class="styled message">
                <label>{{passwordEmailSentMessage}}</label>
              </div>

              <div class="flex text-center center mt-8 mb-8">
                <el-button
                  plain
                  size="small"
                  @click="login"
                  class="box grow login-btn"
                >Back to Login</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </vue-scroll>
</template>

<script>
import { mapGetters } from "vuex";
import {
  AUTH_RESET_EMAIL,
  AUTH_RESET_EMAIL_CLEAR
} from "@/store/modules/auth/auth.type";
import { emailRe } from "@/utilities/regex/email";

export default {
  name: "ForgotPassword",
  data() {
    return {
      userForm: {
        email: ""
      },
      userRules: {
        email: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please input the user's email address"));
              } else {
                emailRe.test(value)
                  ? callback()
                  : callback(new Error("Invalid email format"));
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    login() {
      this.$store.dispatch(AUTH_RESET_EMAIL_CLEAR);
      this.$router.push({ name: "login" });
    },
    emailPasswordReset() {
      this.$refs["resetRef"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch(AUTH_RESET_EMAIL, { email: this.userForm.email })
            .then(
              () => {
                // do nothing
              },
              errMsg => {
                console.log(errMsg);
              }
            );
        }
      });
    }
  },
  computed: {
    ...mapGetters(["isPasswordEmailSent", "passwordEmailSentMessage"])
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/global_classes.css";
@import "assets/styles/text.css";
@import "assets/styles/login.css";

.layout-container .container .view {
  padding: 0px;
  padding-bottom: 0px;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.message {
  margin: 10px 0px;
}

.company-desc {
  font-size: 0.8em;
  color: black;
  margin-top: 24px;
}

.desc {
  font-size: 0.8em;
  color: black;
  margin-top: 68px;
}

>>> .el-loading-mask {
  background-color: white;
}

.logo-container {
  > div {
    height: 170px; /* Match height of right grid content */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/ForgotPassword.vue